import React from 'react';
import { Button } from 'antd';

const sortText = (a, b) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;

  return String(a).localeCompare(String(b));
};

export const buildTankAddModalColumns = ({
  getTankUseStatus,
  getTankChargeStatus,
  onAddTank,
  isAddDisabled = () => false,
}) => [
  {
    key: 'qrcode',
    dataIndex: 'qrcode',
    title: 'QR 번호',
    width: 180,
    ellipsis: true,
    defaultSortOrder: 'ascend',
    sorter: (a, b) => sortText(a.qrcode, b.qrcode),
    render: (_, record) => record.qrcode ?? '-',
  },
  {
    key: 'serialNo',
    dataIndex: 'serialNo',
    title: '용기 일련번호',
    width: 180,
    ellipsis: true,
    sorter: (a, b) => sortText(a.serialNo, b.serialNo),
    render: (_, record) => record.serialNo ?? '-',
  },
  {
    key: 'useStatus',
    dataIndex: 'useStatus',
    title: '가용상태',
    align: 'center',
    width: 80,
    render: (_, record) => getTankUseStatus(record.useStatus),
  },
  {
    key: 'chargeStatus',
    dataIndex: 'chargeStatus',
    title: '충전상태',
    align: 'center',
    width: 80,
    render: (_, record) => getTankChargeStatus(record.chargeStatus),
  },
  {
    key: 'chargeCount',
    dataIndex: 'chargeCount',
    title: '충전횟수',
    width: 100,
    align: 'right',
    render: (_, record) => Number(record.chargeCount ?? 0).toLocaleString(),
  },
  {
    key: 'location',
    dataIndex: 'location',
    title: '현재 위치',
    width: 220,
    render: (_, record) => (
      <span
        style={{
          display: 'block',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'keep-all',
          lineHeight: 1.4,
        }}>
        {record.location?.name ?? '-'}
      </span>
    ),
  },
  {
    key: 'add',
    dataIndex: 'add',
    align: 'center',
    title: '추가',
    width: 104,
    render: (_, record) => (
      <Button disabled={isAddDisabled(record)} onClick={() => onAddTank(record)} type="primary" style={{ minWidth: 76 }}>
        추가하기
      </Button>
    ),
  },
];
